import { EntityType, ServiceAccountDraft } from "../../../../../models";
import { ErrorActions } from "../../../../flux/Error/ErrorActions";
import { Polyglot } from "../../../../../polyglot";
import { Command1 } from "../../../../../Command";
import { UpsertCommand } from "../../commands/UpsertCommand";

export class UpsertServiceAccountCommand implements Command1<ServiceAccountDraft>
{
    private errorActions = new ErrorActions();

    constructor(private polyglot: Polyglot, private errorDispatchToken: string, private upsert: UpsertCommand)
    {
    }
    
    execute = (draft: ServiceAccountDraft) => {
        const { DivisionId, ServerUrl } = draft;
        const setError = (msg: string) => this.errorActions.setError(new Error(msg), this.errorDispatchToken);
        
        if(typeof DivisionId !== 'number') {
            setError(this.polyglot.t('service_account.validation_err.division_not_set'));
            return;
        }
        if(typeof ServerUrl !== 'string' || ServerUrl === '') {
            setError(this.polyglot.t('service_account.validation_err.invalid_server_url'));
            return;
        }

        this.upsert.execute(draft, EntityType.ServiceAccount);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/ServiceAccount/commands/UpsertServiceAccountCommand.ts